module.exports = __webpack_public_path__ + "SourceSansPro-LightItalic.52eacfdf46e3c5f3b4e6.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-LightItalic.eot
// module id = ../../../../../src/assets/customfonts/SourceSansPro-LightItalic.eot
// module chunks = styles